import { gql } from "@apollo/client";

export default gql`
  query preferred($first: Int, $last: Int, $after: String, $before: String, $workerId: String) {
    preferred(first: $first, last: $last, after: $after, before: $before, workerId: $workerId) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          workerId
          employerId
          type
          isNotified
          notifyAfter
          notifyAfterUtc
          reason
          createdAt
          createdAtUtc
          worker {
            id
            firstName
            lastName
            email
            rating
            noShowCount
          }
          employer {
            id

            companyName
          }
        }
      }
    }
  }
`;
